/**
 *项目通用方法
 */
import * as language from "@/language/index.js";
import * as config from "@/config/index.js";
import * as protocol from "@/config/protocol.js";

//获取语言类型
export const getLang = (lang , key) => {
  let result = language.zh.LANGUAGE[key];
  switch(Number(lang)){
    case 1:
      result = language.zh.LANGUAGE[key]
      break;
    case 2:
      result = language.tw.LANGUAGE[key]
      break;
    case 3:
      result = language.en.LANGUAGE[key]
      break;
  }
  return result;
}

//获取webinfo
export const getWebinfo = (webid) => {
  let WEBDEFAULTLIST = config.WEBDEFAULTLIST;
  let result = {};
  switch(Number(webid)){
    case 93:
      //烈火测试服
      result = WEBDEFAULTLIST.test;
      break;
    case 92:
      //本地调试服
      result = WEBDEFAULTLIST.debug;
      break;
    case 129:
      //娱乐圈测试服
      result = WEBDEFAULTLIST.test;
      break;
    default:
      result = WEBDEFAULTLIST.formal;
      break;
  }
  return result;
}

//获取协议文本
export const getProtocol = (lang,prorocolType,companyid) => {
  let result = "";
  switch(lang){
    case 2:
      result = protocol[prorocolType+"_tw"]();
      break;
    case 3:
      result = protocol[prorocolType+"_en"]();
      break;
    default:
      result = protocol[prorocolType+"_zh"]();
      break;
  }
  return result;
}

//构造路由跳转参数
export const getRouterConfig = (page,params) => {
  let result = {};
  let userInfo = params.userInfo;
  result.path = "/" + page + "/" + params.webid + "/" + params.lang + "/" +userInfo.serverId + "/" + userInfo.userId;
  result.query = {};
  if (userInfo.name) {
    result.query.name = encodeURI(userInfo.name);
  }
  if (userInfo.vip) {
    result.query.vip = userInfo.vip;
  }
  if (params.param) {
    result.query.param = encodeURI(params.param);
  }
  return result;
}

//获取系统语言
export const getSystemLang = () => {
  let lang;
  let language;
  if (navigator.language) {
    language = navigator.language;
  }
  switch (language) {
    case "zh-CN": lang = "zh"; break;//"中文(简体)"
    case "zh-tw": lang = "tw"; break;//"中文(繁体)"
    default: lang = "tw"; break;
  }
  return lang;
}

// 判断设备型号
export const isPC = () => {
  let os = new Array("Android", "iPhone", "Windows Phone", "iPod", "BlackBerry", "MeeGo", "SymbianOS"); // 其他类型的移动操作系统类型，自行添加
  let info = navigator.userAgent;
  let len = os.length;
  for (let i = 0; i < len; i++) {
    if (info.indexOf(os[i]) > 0) {
      return false;
    }
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/utils/common.js